<template>
    <main class="grid gap-4 justify-center pb-2">
      <section>
        <div class="flex gap-2 items-center">
          <img src="../../assets/gPay-Share.svg" class="w-9 h-9" alt="">
          <p class="text-sm font-myriad font-semibold text-textSecondary">Share invite link with the supplier | <span @click.prevent="$filters.gPayCopyToClipboard(queryData.shareUrl), copyTextChanges()" class="text-primaryLight underline">{{ copyText }}</span></p>
        </div>
      </section>
      <hr/>
      <section class="grid">
        <article class="grid grid-cols-3 justify-items-center">
          <div class="grid justify-items-center gap-2" @click.prevent="shareContent('whatsapp')">
            <img src="../../assets/gPay-WhatApp.svg" class="w-12 h-12" alt="WhatApp">
            <p class="text-sm font-myriad font-semibold text-textSecondary">Whatsapp</p>
          </div>
          <div class="grid justify-items-center gap-2" @click.prevent="shareContent('email')">
            <img src="../../assets/gPay-Email.svg" class="w-12 h-12" alt="WhatApp">
            <p class="text-sm font-myriad font-semibold text-textSecondary">Email</p>
          </div>
          <div class="grid justify-items-center gap-2" @click.prevent="shareContent('sms')">
            <img src="../../assets/gPay-Sms.svg" class="w-11 h-11" alt="WhatApp">
            <p class="text-sm font-myriad font-semibold text-textSecondary">SMS</p>
          </div>
        </article>
      </section>
    </main>
  </template>
  <script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Share Content',
    data() {
      return {
        queryData: this.$route.query,
        copyText: "Copy link"
      };
    },
    components: {},
    computed: {
      ...mapGetters([]),
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
      },
      shareContent(data) {
        const url = encodeURIComponent(this.queryData.shareUrl);
        if (data === 'whatsapp') {
          window.microapps.openUrl({ url: `https://api.whatsapp.com/send?text=${url}` });
        } else if (data === 'email') {
          const subject = encodeURIComponent('ePayLater Supplier On-boarding');
          const body = encodeURIComponent(`Please click the link and complete the on-boarding form so that I can start making payments to you using ePayLater: ${this.queryData.shareUrl}`);
          const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
          window.microapps.openUrl({ url: mailtoLink });
        } else if (data === 'sms') {
          const phoneNumber = ''; // Replace with the recipient's phone number
          const message = `Please click the link and complete the on-boarding form so that I can start making payments to you using ePayLater: ${this.queryData.shareUrl}`;
          const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;
          window.microapps.openUrl({ url: smsLink });
        }
      },
      copyTextChanges() {
        this.copyText = "Copied";
        setTimeout(() => {
          this.copyText = "Copy link";
        }, 2000);
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  </style>
